import { PartnerAccountDecisionStep } from "#/components/telemedicine/steps/PartnerAccountDecisionStep"
import { NoPartnerAccessStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/NoPartnerAccessStep"
import { NoPartnerAccountStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/NoPartnerAccountStep"
import { ResendPartnerInviteStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/ResendPartnerInvite"
import { SignInAsMemberStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/SignInAsMemberStep"
import { SignInAsPartnerStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/SignInAsPartnerStep"
import { WhoWillBeReceivingCareStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/WhoWillBeReceivingCareStep"
import { YouAreLeavingCarrotStep } from "#/components/telemedicine/pelvic-floor-therapy/steps/YouAreLeavingCarrotStep"

export enum Steps {
  WHO_WILL_RECEIVING_CARE = "Who will be receiving care",
  NO_PARTNER_ACCOUNT = "No partner account",
  NO_PARTNER_ACCESS = "No partner access",
  SIGN_IN_AS_PARTNER = "Sign in as the partner",
  SIGN_IN_AS_MEMBER = "Sign in as the member",
  YOU_ARE_LEAVING_CARROT = "You are leaving Carrot",
  RESEND_PARTNER_INVITE = "Resend partner invite",
  PARTNER_ACCOUNT_DECISION = "Partner account decision"
}

export enum Workflows {
  TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_MEMBER = "telemedicineForPelvicFloorTherapyMember",
  TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_PARTNER = "telemedicineForPelvicFloorTherapyPartner"
}

// prettier-ignore
export const telemedicineForPelvicFloorTherapySteps = [
  { name: Steps.WHO_WILL_RECEIVING_CARE,    component: WhoWillBeReceivingCareStep },
  { name: Steps.PARTNER_ACCOUNT_DECISION,   component: PartnerAccountDecisionStep, decisionStep: true },
  { name: Steps.NO_PARTNER_ACCESS,          component: NoPartnerAccessStep },
  { name: Steps.NO_PARTNER_ACCOUNT,         component: NoPartnerAccountStep },
  { name: Steps.SIGN_IN_AS_PARTNER,         component: SignInAsPartnerStep },
  { name: Steps.YOU_ARE_LEAVING_CARROT,     component: YouAreLeavingCarrotStep },
  { name: Steps.SIGN_IN_AS_MEMBER,          component: SignInAsMemberStep },
  { name: Steps.RESEND_PARTNER_INVITE,      component: ResendPartnerInviteStep }
]

// prettier-ignore
const memberFlow = [
  { at: Steps.WHO_WILL_RECEIVING_CARE,  given: "MEMBER",                          goto: Steps.YOU_ARE_LEAVING_CARROT },
  { at: Steps.WHO_WILL_RECEIVING_CARE,  given: "PARTNER",                         goto: Steps.PARTNER_ACCOUNT_DECISION },
  { at: Steps.PARTNER_ACCOUNT_DECISION, given: "PARTNER_ACCOUNT_ACTIVE",          goto: Steps.SIGN_IN_AS_PARTNER },
  { at: Steps.PARTNER_ACCOUNT_DECISION, given: "PARTNER_ACCESS_NO_ACCOUNT",       goto: Steps.NO_PARTNER_ACCOUNT },
  { at: Steps.PARTNER_ACCOUNT_DECISION, given: "NO_PARTNER_ACCESS",               goto: Steps.NO_PARTNER_ACCESS },
  { at: Steps.PARTNER_ACCOUNT_DECISION, given: "PARTNER_INVITATION_NOT_ACCEPTED", goto: Steps.RESEND_PARTNER_INVITE }
]

// prettier-ignore
const partnerFlow = [
  { at: Steps.WHO_WILL_RECEIVING_CARE,  given: "MEMBER",  goto: Steps.SIGN_IN_AS_MEMBER },
  { at: Steps.WHO_WILL_RECEIVING_CARE,  given: "PARTNER", goto: Steps.YOU_ARE_LEAVING_CARROT }
]

export const telemedicineForPelvicFloorTherapyWorkflows = [
  { name: Workflows.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_MEMBER, workflow: memberFlow },
  { name: Workflows.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_PARTNER, workflow: partnerFlow }
]
